import React from "react";
import { Link } from "react-router-dom";

export type BreadcrumbLink = {
    label: string,
    url: string,
}

type BreadcrumbProps = {
    link: BreadcrumbLink;
    current: boolean;
    links: BreadcrumbLink[]
};

const BreadCrumb = ({
    link,
    current,
    links = null
}: BreadcrumbProps) => {
    return (
        <div className="justify-start items-start gap-3 inline-flex">
            <Link className={"text-brand-500 hover:underline"} to={link.url}>{link.label}</Link>
            {
                !current && (
                    <span className="text-gray-500">/</span>
                )
            }
            {
                links?.length === 1
                    ? <span className="text-gray-500">/</span>
                    : null
            }
        </div>
    );
};

type BreadcrumbsProps = {
    links: BreadcrumbLink[]
};

const Breadcrumbs = ({ links }: BreadcrumbsProps) => {

    const isCurrent = (i: number) => {
        return i === links.length - 1;
    };

    return (
        <div className="justify-start items-start gap-3 inline-flex shadow-none">
            {
                links.map(
                    (link: BreadcrumbLink, i: number, links: BreadcrumbLink[] = null) => (
                        <BreadCrumb key={i} link={link} current={isCurrent(i)} links={links}/>
                    )
                )
            }
        </div>
    );
};

export default Breadcrumbs;
